import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminDepositService } from '@/modules/deposit/services/admin-deposit.service'
import { DepositPayOffRequestModel } from '@/modules/deposit/models/deposit-request.model'

@vservice()
export class AdminDepositPayOffUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminDepositService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(id: number, data: DepositPayOffRequestModel) {
    return this.service.payOff(id, { ...data, reception_image: data.reception_image[0] })
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }


}
